import Vue from "vue";
import Vuex from "vuex";
import API_GROUPS from "../../api/groups.api";

Vue.use(Vuex);

export const INITIAL_STATE = {
  groups: [],
};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    groups: (state) => state.groups,
  },
  mutations: {
    fetch_groups(state, groups) {
      state.groups = groups ?? [];
    },
  },
  actions: {
    async fetch_groups({ commit, getters }) {
      const response = await API_GROUPS.getGroups(getters.selectedClient.id);
      commit("fetch_groups", response);
      return response ? "OK" : "KO";
    },

    async post_group({ getters, dispatch }, data) {
      if (data.id) {
        await API_GROUPS.updateGroup(getters.selectedClient.id, data);
      } else {
        await API_GROUPS.createGroup(getters.selectedClient.id, data);
      }
      await dispatch("fetch_groups");
      return "OK";
    },

    async delete_group({ getters, dispatch }, data) {
      await API_GROUPS.deleteGroup(getters.selectedClient.id, data);
      await dispatch("fetch_groups");
      return "OK";
    },
  },
};
